import React, { useEffect, useState } from "react";
import LivePl from "../LivePl/LivePl";
import toast from "react-hot-toast";
import Backend from "../../Backend/Backend";
import { useSelector } from "react-redux";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

export default function EditOptions(props) {
  const user_id = props.user_id;

  const [loading, setLoading] = useState(false);

  const [standing, setStanding] = useState(false);

  const [credit, setCredit] = useState(false);
  const [deposit_current, setDepositCurrent] = useState(false);
  const [profit_loss, setProfitLoss] = useState(false);
  const [equity, setEquity] = useState(false);
  const [margin, setMargin] = useState(false);
  const [marginfree, setMarginFree] = useState(false);

  useEffect(() => {
    loadProfitLoss();
  }, [user_id]);

  const loadProfitLoss = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user_id,
    };
    backend.profit_loss_master(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setCredit(r.credit);
        setDepositCurrent(r.deposit_current);
        setProfitLoss(r.profit_loss);
        setEquity(r.equity);
        setMargin(r.margin);
        setMarginFree(r.marginfree);

        setStanding(r.standing);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div className="NavSubContainer footer hover">
      <div className="NavSubLeft"></div>
      <div className="NavSubRight">
        <div
          className="text large"
          style={{
            marginLeft: 10,
            marginRight: 10,
            borderRadius: 4,
            paddingLeft: 10,
            paddingRight: 10,
            display: "flex",
          }}
        >
          BOOKED :{" "}
          <div
            style={{ paddingLeft: 5 }}
            className={`${profit_loss > 0 ? "buytext" : "selltext"} `}
          >
            {" "}
            {fmt.format(profit_loss)}
          </div>
        </div>
      </div>
    </div>
  );
}
